<template>
  <div class="linkations-list">
    <table class="apoio-datatable">
      <colgroup>
        <col class="column-fileName">
        <col class="column-exam">
        <col class="column-actions">
      </colgroup>
      <thead>
        <tr class="apoio-datatable__header-line">
          <th
            title="Nome"
            class="column-fileName"
          >
            NOME DO DOCUMENTO
          </th>
          <th
            title="Exame"
            class="column-exam"
          >
            EXAME
          </th>
          <th
            title="Ações"
            class="column-actions"
          >
            AÇÕES
          </th>
        </tr>
      </thead>
    </table>

    <table
      ref="tableDocuments"
      class="
        apoio-datatable apoio-datatable-alt apoio-datable-margin-linkations
      "
    >
      <colgroup>
        <col class="column-fileName">
        <col class="column-exam">
        <col class="column-actions">
      </colgroup>

      <tbody>
        <tr
          v-for="(linkation, rowIndex) in linkations"
          :key="rowIndex"
        >
          <td
            class="column-fileName"
            :title="linkation.fileName"
          >
            {{ linkation.fileName }}
          </td>
          <td
            class="column-exam"
            :title="linkation.examName"
          >
            {{ linkation.examName }}
          </td>
          <td class="column-actions">
            <div>
              <div
                class="status-icon icon-delete-alt"
                @click="deleteLinkation(linkation.id_document_template_exam)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="loading">
        <tr>
          <td colspan="10">
            <infinite-loading
              ref="infiniteLoading"
              :on-infinite="onInfinite"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/common/Spinner'

export default {
  name: 'FileList',
  components: {
    'infinite-loading': InfiniteLoading,
    'card-form': CardForm,
    spinner: Spinner
  },
  props: {
    linkations: Array,
    getAllLinkations: Function,
    loading: Boolean
  },
  methods: {
    onInfinite () {
      this.getAllLinkations()
    },
    deleteLinkation (fileId) {
      this.$emit('delete-linkation', fileId)
    }
  }
}
</script>

<style lang="scss">
.linkations-list {
  width: 100%;

  .apoio-datatable {
    margin: 0px;
  }

  .apoio-datatable-alt {
    margin-bottom: 3em;
  }

  .column-fileName {
    width: 40%;
    text-overflow: ellipsis !important;
  }

  .column-exam {
    width: 40%;
    text-overflow: ellipsis !important;
  }
  .column-actions {
    width: 20%;
  }
}
</style>
